enum IssueServiceType {
    None = "None",
    DamagedPackages = "DamagedPackages",
    MissingPackages = "MissingPackages",
    OvershippedItems = "OvershippedItems",
    MissingItems = "MissingItems",
    DamagedItems = "DamagedItems"
}

export default IssueServiceType;